import { PropsWithChildren } from "react";
import styled from "styled-components";

type PropsContainerDiv = {
    percent: number;
    className?: string;
    width?: number;
    fontSize?: number;
    ignorePercentLabel?: boolean;
}

const ContainerDiv = ({ className, children }: PropsWithChildren<PropsContainerDiv>) => {
    return <div className={className}>
        {children}
    </div>
}


export const Container = styled(ContainerDiv)`
    & > .c-circular-progress.mobile-circular-progress {
        width: 65px;
        height: 65px;
    }

    & > .c-circular-progress {
        width: ${props => (props.width ?? 20) + 'rem'};
        height: ${props => (props.width ?? 20) + 'rem'};
        background: ${props => {
        let deg = 0
        for (let i = 0; i < 100; i++) {
            deg = 90 + (3.6 * i);
            if (i === props.percent) {
                const colorFill = props.theme.colors.primary;
                const colorbackground = '#e0e0e0'
                let direction = i < 51 ? 'right' : 'left';
                const color = i < 51 ? colorbackground : colorFill;

                return `linear-gradient(to ${direction}, ${color} 50%, transparent 50%),
                        linear-gradient(${deg}deg, ${colorFill} 50%, ${colorbackground} 50%)`
            }
        }
    }};
        &:before {
            background-color: #5D5D5D;
            color: white;
            font-size: ${props => (props.fontSize ?? 8) + 'rem'};
            content: '${props => {
        if (props.ignorePercentLabel) {
            return undefined
        }
        else {
            return props.percent + '%';
        }
    }}'
        }
    }
`;